module.exports = __webpack_public_path__ + "img/frame_give_titlebg.5f0b3a19.png";